module.exports = require('./helpers/bundle-url').getBundleURL('fw7YH') + "logo-dark.eefe0b7f.svg";